import { render, staticRenderFns } from "./CreateSubstance.vue?vue&type=template&id=ab89e518&"
import script from "./CreateSubstance.vue?vue&type=script&lang=js&"
export * from "./CreateSubstance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports